import { t } from '@lingui/macro'

import { Markdown } from '@/@bothrs-ui/web/components/markdown/Markdown'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { useTranslated } from '@/utils/translation'
import { BookingFlowActions, BookingFlowCenteredContent, BookingFlowLayout } from './BookingFlowLayout'

type DisclaimerContentProps = {
  onAction: (action: 'disclaimer-submit') => void
  isLoading?: boolean
}

export const DisclaimerContent = ({ onAction, isLoading }: DisclaimerContentProps) => {
  const termsConditionsUrl = useTranslated('terms-conditions.url')
  const privacyPolicyUrl = useTranslated('privacy-policy.url')

  const introText = t({
    id: 'appointments.book.disclaimer.introduction',
    message:
      'Op de volgende schermen stellen we je enkele vragen om je zorgvraag beter te kunnen inschatten en je afspraak correct te kunnen inplannen bij de juiste specialist. Gelieve de vragen waarheidsgetrouw te beantwoorden.',
  })

  const emergencyWarningText = t({
    id: 'appointments.book.disclaimer.emergencyWarning',
    message:
      'Heb je echter ernstige of plotse klachten? Neem dan contact op met het secretariaat van de dienst. Kan je het secretariaat niet bereiken, neem dan contact met je huisarts (buiten de kantooruren van je huisarts kan je terecht bij een dokter van wacht via het nummer 1733) of ga naar de spoedafdeling van het ziekenhuis.',
  })

  const lifeThreateningWarningText = t({
    id: 'appointments.book.disclaimer.lifeThreateningWarning',
    message: 'Gaat het om een levensbedreigende situatie, bel dan onmiddellijk 112.',
  })

  let linksText = ''
  if (termsConditionsUrl || privacyPolicyUrl) {
    linksText +=
      t({
        id: 'appointments.book.disclaimer.termsLink',
        message: 'Bekijk hier onze',
      }) + ' '

    if (termsConditionsUrl) {
      const label = t({
        id: 'global.generalTerms',
        message: 'gebruiksvoorwaarden',
      })
      linksText += `[${label}](${termsConditionsUrl})`
    }

    if (termsConditionsUrl && privacyPolicyUrl) {
      linksText += ' en '
    }

    if (privacyPolicyUrl) {
      const label = t({
        id: 'global.privacyPolicy',
        message: 'privacyvoorwaarden.',
      })
      linksText += `[${label}](${privacyPolicyUrl})`
    }
  }

  const content = [introText, emergencyWarningText, lifeThreateningWarningText, linksText].filter(Boolean).join('\n\n')

  return (
    <BookingFlowLayout>
      <BookingFlowCenteredContent>
        <Markdown content={content} typography='BodyMediumRegular' />
      </BookingFlowCenteredContent>

      <BookingFlowActions>
        <Button
          variant='Primary'
          onClick={() => onAction('disclaimer-submit')}
          disabled={isLoading}
          isLoading={isLoading}
        >
          {t({
            id: 'global.continue',
            message: 'Ga verder',
          })}
        </Button>
      </BookingFlowActions>
    </BookingFlowLayout>
  )
}
